import guestRepository from "@/repositories/guestRepository";

export const getAll = async (params) => {

    try{
        const res = await guestRepository.getAll(params);
        return res.data.data;
    } catch(err){
        console.error(err)
        throw err;
    }
}
export const create = async (data) => {

    try{
        const res = await guestRepository.create(data);
        return res.data.data;
    } catch(err){
        console.error(err)
        throw err;
    }
}